import {WORKSITE_REFERENCES_APPROVERS} from "./constants";

export const checkIfReferenceClosed = (approvals) => {
  if (!approvals || approvals.length === 0)
    return false;
  return WORKSITE_REFERENCES_APPROVERS
    .map((wra) => wra.name)
    .every((approverType) => {
      const currentTypeApprovals = approvals.filter((a) => a.des_approval_type === approverType);
      return currentTypeApprovals.length > 0 && currentTypeApprovals.every((cta) => cta.tms_approved_on)
    })
}